// Grows the message box with its text, one line at a time, until the CSS max-height; past that it
// scrolls inside. Neither Firefox nor Chromium resizes a textarea to its content on its own (and
// `rows = 1` alone kept multi-line drafts squeezed into one line), so the height is set by hand.
type Sizable = Pick<HTMLTextAreaElement, 'scrollHeight' | 'clientHeight'> & { style: Pick<CSSStyleDeclaration, 'height' | 'overflowY'> };
type Scroller = Pick<HTMLElement, 'scrollHeight' | 'scrollTop' | 'clientHeight'>;

export function fitComposerInput(input: Sizable, history: Scroller | null, borders: number): void {
  // Growing the box shrinks the history above it: keep the newest messages in view if they were.
  const atBottom = history ? history.scrollHeight - history.scrollTop - history.clientHeight < 48 : false;
  // 'auto' first so the box can also shrink back (after deleting lines or sending).
  input.style.height = 'auto';
  // scrollHeight covers content and padding; with border-box sizing the borders come on top.
  input.style.height = `${input.scrollHeight + borders}px`;
  // Once max-height clamps the box, let it scroll; below that, no scrollbar flashes while typing.
  input.style.overflowY = input.scrollHeight > input.clientHeight ? 'auto' : 'hidden';
  if (history && atBottom) history.scrollTop = history.scrollHeight;
}
